import { SortOrder } from './sortOrder';

export class PagingDto {
  page = 1;
  sortOrder: SortOrder = SortOrder.LATEST;
  total?: number;
}
